import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import "../UiStyle/Others.css";

const DrugPolicy = () => {
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={"Drug Policy"} pagesub={"Drug Policy"} />
      <div className="container policy" style={{ marginTop: 50 }}>
        <p className="mb-4">
          At <strong>Chemist For All</strong>, we are committed to offering
          high-quality, affordable generic medicines to support accessible
          healthcare for all. Generic medicines are pharmaceutical products that
          contain the same active ingredients, strength, dosage form, and route
          of administration as their brand-name counterparts. They are approved
          for use only after being proven to be bioequivalent to the original
          branded drug, ensuring the same therapeutic benefits and safety
          profile.
        </p>

        <p className="mb-4">
          Generic medicines are significantly more affordable because their
          manufacturers do not bear the high costs associated with drug
          discovery, development, and marketing. Original brand-name drugs
          typically involve years of research, clinical trials, regulatory
          approvals, and large-scale promotional efforts. Once the patent
          protection on these drugs expires, generic versions can be produced
          using existing formulations, thereby reducing development costs. As a
          result, generic manufacturers can offer the same medicines at a
          fraction of the cost, passing the savings on to patients.
        </p>

        <p className="mb-4">
          All the generic medicines available on our platform are sourced from
          trusted and certified manufacturers with international regulatory
          approvals. We do not sell controlled substances or narcotics. Our
          offerings are strictly intended for personal use and not for resale or
          commercial distribution.
        </p>

        <p className="mb-4">
          Brand names mentioned on the site are provided solely for
          informational and identification purposes. We are not affiliated with
          the trademark holders of any branded products and make no claim of
          association. When a specific brand is unavailable, a therapeutically
          equivalent generic from a reputable manufacturer may be supplied.
        </p>

        <p className="mb-4">
          We encourage all users to consult with their licensed healthcare
          provider before using any medication purchased through our site. While
          we aim to provide helpful information, it is not intended to replace
          professional medical advice, diagnosis, or treatment.
        </p>
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default DrugPolicy;
